export default "__VITE_ASSET__BhUzl0IQ__"